import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import config from '../../config'

import { IAddFn, ISafetyReport, ISafetyReportAddUpsert } from '../../interfaces'

type Params = {
  portalKey: string
}

const getCreateSafetyReportMutationRequest = (params: Params) => {
  const portalKey = params?.portalKey
  return {
    method: 'post',
    url: `${config.baseUrl}/sms/SafetyReport/${portalKey}`,
  }
}

const useCreateSafetyReportMutation = (params: Params, options = {}) => {
  const request = useMemo(() => getCreateSafetyReportMutationRequest(params), [params])

  const createSafetyReport: IAddFn<ISafetyReportAddUpsert, ISafetyReport> = useCallback(
    async data => axios({ ...request, data }).then(res => res.data),
    [request],
  )

  const response = useMutation<ISafetyReport, Error, ISafetyReportAddUpsert>({
    mutationFn: createSafetyReport,
    ...options,
  })

  return response
}

export default useCreateSafetyReportMutation
